import { Col, Row } from "react-bootstrap";
import { WfsParametersV1 } from "../../../types/Wfs/WfsParametersV1";

export interface WfsParametersDisplayPropsV1Props {
  areaDescription: string | undefined;
  wfsParameters: WfsParametersV1;
}

/*
This is a control to display legacy WfsParameters
*/
const WfsParametersDisplayV1 = ({
  areaDescription,
  wfsParameters,
}: WfsParametersDisplayPropsV1Props) => {
  return (
    <>
      <Row>
        <Col md="3">Area</Col>
        <Col md="9" className="text-capitalize">
          {areaDescription}
          {!areaDescription && wfsParameters.withinBoundaryName && (
            <>
              {wfsParameters.withinBoundaryName}
              {wfsParameters.boundaryBuffer !== null && (
                <>+{wfsParameters.boundaryBuffer}m</>
              )}
            </>
          )}
          {!areaDescription && wfsParameters.bBox && (
            <>within bounding box ({wfsParameters.bBox})</>
          )}
        </Col>
      </Row>
      <Row>
        <Col md="3">Filter</Col>
        <Col md="9" className="text-capitalize">
          {wfsParameters.filter ?? "None"}
        </Col>
      </Row>
      <Row>
        <Col md="3">Format</Col>
        <Col md="9" className="text-capitalize">
          {wfsParameters.outputFormat}
        </Col>
      </Row>
      {wfsParameters.count && (
        <Row>
          <Col md="3">Count</Col>
          <Col md="9">{wfsParameters.count}</Col>
        </Row>
      )}
      {wfsParameters.startIndex && (
        <Row>
          <Col md="3">Start Index</Col>
          <Col md="9">{wfsParameters.startIndex}</Col>
        </Row>
      )}
      {wfsParameters.sortBy && (
        <Row>
          <Col md="3">Sort By</Col>
          <Col md="9">{wfsParameters.sortBy}</Col>
        </Row>
      )}
      {wfsParameters.srsName && (
        <Row>
          <Col md="3">SRS Name</Col>
          <Col md="9">{wfsParameters.srsName}</Col>
        </Row>
      )}
    </>
  );
};

export default WfsParametersDisplayV1;
